import React from 'react'
import Layout from '../components/layout'
import { Line } from "react-chartjs-2";
import { Bar } from "react-chartjs-2";
import { Pie } from "react-chartjs-2";
import { Doughnut } from "react-chartjs-2";
import "chart.js/auto";

function Reports() {

    const data = {
        churnRate: {
            labels: ["JAN", "FEB", "MAR", "APR"],
            datasets: [
                {
                    label: "Churn Rate",
                    data: [2.5, 2.2, 2.8, 2.0],
                    borderColor: "#c7852a",
                    backgroundColor: "rgba(199, 133, 42, 0.2)",
                    borderWidth: 2,
                },
            ],
        },
        engagement: {
            labels: ["Website Visits", "App Usage", "Support Tickets"],
            datasets: [
                {
                    label: "Engagement Metrics",
                    data: [15000, 12000, 500],
                    backgroundColor: "#c7852a",
                    
                },
            ],
        },
        retentionRate: {
            labels: ["Loans", "Investments", "Credit Cards", "Savings"],
            datasets: [
                {
                    label: "Retention Rate",
                    data: [92, 85, 88, 90],
                    backgroundColor: ["#c7852a", "#b4741f", "#a46315", "#8a5210"],
                },
            ],
        },
    };
    const barOptions = {
        indexAxis: 'y',
      };

    return (
        <Layout>
            <div className="p-6 bg-[#F9F5F1] h-full flex flex-col items-center overflow-scroll hide-scrollbar">
                <h1 className="text-lg md:text-xl lg:text-2xl xl:text-3xl font-semibold text-[#b4741f] mb-6">Customer Retention Report</h1>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 w-full max-w-6xl">
                    {/* Churn Rate Over Time */}
                    <div className="bg-white p-4 shadow rounded-xl border border-[#d8c9ae]">
                        <h2 className="text-[#b4741f] font-bold">CHURN RATE OVER TIME</h2>
                        <Line data={data.churnRate} />
                    </div>

                    
                    {/* Customer Engagement Metrics */}
                    <div className="bg-white p-4 shadow rounded-xl border border-[#d8c9ae]">
                        <h2 className="text-[#b4741f] font-bold">CUSTOMER ENGAGEMENT METRICS</h2>
                        <Bar data={data.engagement} />
                    </div>

                    {/* Retention Rate by Product/Service */}
                    <div className="bg-white p-4 shadow rounded-xl border border-[#d8c9ae] flex flex-col justify-evenly items-center">
                        <h2 className="text-[#b4741f] font-bold">RETENTION RATE BY PRODUCT/SERVICE</h2>
                        <Pie data={data.retentionRate}  className="max-h-96 max-w-96"/>
                    </div>
                    {/* Retention Rate by Product/Service */}
                    <div className="bg-white p-4 shadow rounded-xl border border-[#d8c9ae] flex flex-col justify-evenly items-center">
                        <h2 className="text-[#b4741f] font-bold">RETENTION RATE BY PRODUCT/SERVICE</h2>
                        <Doughnut data={data.retentionRate}  className="max-h-96 max-w-96"/>
                    </div>
                    {/* Customer Engagement Metrics */}
                    <div className="bg-white p-4 shadow rounded-xl border border-[#d8c9ae] md:col-span-2 ">
                        <h2 className="text-[#b4741f] font-bold">CUSTOMER ENGAGEMENT METRICS</h2>
                        <Bar data={data.engagement} options={barOptions}/>
                    </div>
                </div>
            </div>
        </Layout>
    )
}

export default Reports